import { DateRangePicker } from '@repo/ui/DateRangePicker';
import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { SelectorInputField, TextInputField } from '@repo/ui/Form';
import { registerDateRange, registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';
import type { SelectInputOptions } from '@repo/types/Types';
import React from 'react';
import { useFormState } from 'react-hook-form';
import { TableReportExporter } from '@/features/monitoring/components/reports/TableReportExporter';
import { Mercury } from '@repo/types/Models';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';

interface DidsTableFilterProps {
  TYPES: SelectInputOptions;
  queryList: Mercury.Queries.QueryList;
  hasContent?: boolean;
}

const DidsTableFilter = ({ TYPES, queryList, hasContent }: DidsTableFilterProps) => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;

  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }

  const exportInput = {
    queryList: queryList,
    first: 200,
    optionalFields: [
      { field: 'account_id', as: 'Account ID' },
      { field: 'csp_campaign_id', as: 'Campaign ID' },
      {
        field: 'inserted_at',
        as: 'Inserted At',
      },
      { field: 'mms_enabled', as: 'MMS Enabled' },

      { field: 'sms_enabled', as: 'SMS Enabled' },

      { field: 'type', as: 'Type' },
    ],
    requiredFields: [
      { field: 'number', as: 'Number' },
      { field: 'id', as: 'ID' },
    ],
  };

  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Number" {...registerInput(filter, 'number')} />

        <SelectorInputField label="Type" options={TYPES} {...registerInput(filter, 'type')} />
      </TableFilterSection>

      <div className="flex gap-5">
        {POLICIES['dids:export'](user) && (
          <TableReportExporter
            hasContent={hasContent}
            input={exportInput}
            filename="numbers"
            path={`accounts/${accountId}/dids`}
            title="Export Numbers table"
          >
            Export Table
          </TableReportExporter>
        )}
        <TableFilterButtons className="ml-auto" />
      </div>
    </TableFilterCard>
  );
};

export default DidsTableFilter;
